import Vue from 'vue'
import Vuex from 'vuex'

// General
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import profileSettings from './profile-settings/profilesettings.module';
import loader from './app/loader.module';
import auth from './auth/auth.module';

// Management
import userManagement from './management/user-manage/user.module';
import userPersonelManagement from './management/user-manage/userPersonel.module';

import orderManagement from './management/order-manage/order.module';
import orderPromotionManage from './management/order-promotion-manage/orderPromotionManage.module';

import sourceDataManagement from './ancestry-data/source-data-manage/sourceData.module';
import presetMapManagement from './ancestry-data/preset-map-manage/presetMap.module';
import presetFarmersHgsManagement from './ancestry-data/farmers-hgs-manage/farmersHgs.module'
import ancientProxManagement from './ancestry-data/ancient-prox-manage/ancientProx.module';
import presetRegionManagement from './ancestry-data/preset-region-manage/presetRegion.module';
import presetEthnicityManagement from './ancestry-data/preset-ethnicity-manage/presetEthnicity.module';
import presetAncientPeriodManage from './ancestry-data/preset-ancient-period-manage/presetAncientPeriodManage.module';
import productManagement from './management/product-manage/product.module';
import dataUpdateManagement from './management/data-update-manage/dataUpdate.module';
import paymentManagement from './management/payment-manage/payment.module';
import presetRegionGrupManagement from './ancestry-data/preset-region-grup-manage/presetRegionGrup.module';
import presetMixedModeManage from './ancestry-data/preset-mixedmode-manage/presetMixedModeManage.module';
import presetIndividualManage from './ancestry-data/preset-individual-manage/presetIndividual.module';

import qpadmSampleManagement from './qpadm-data/qpadmSampleManagement.module';

import businessPartnerLink from './business-partner-manage/businessPartnerLink.module';

import subscriptionManage from './management/subscription-manage/subscriptionManage.module';

// Logs
import logsManagement from './management/logs-manage/logs.module';

// Reports
import homeReportManagement from './management/home-report-manage/homeReport.module';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // General
    app,
    auth,
    loader,
    appConfig,
    verticalMenu,
    profileSettings,

    // Management
    userManagement,
    userPersonelManagement,
    
    orderManagement,
    orderPromotionManage,
    sourceDataManagement,
    presetMapManagement,
    presetFarmersHgsManagement,
    presetEthnicityManagement,
    presetAncientPeriodManage,
    ancientProxManagement,
    presetRegionManagement,
    productManagement,
    dataUpdateManagement,
    paymentManagement,
    presetRegionGrupManagement,
    presetMixedModeManage,
    presetIndividualManage,

    qpadmSampleManagement,
    
    businessPartnerLink,

    subscriptionManage,
    
    // Logs
    logsManagement,

    // Reports
    homeReportManagement,
  },
  strict: process.env.DEV,
})
